<template>
  <el-dialog
    v-model="dialogVisible2"
    title="选择图片"
    :width="$store.state.screenWidth > 1200 ?'954px':'98%'"
    align-center
    @close="uploadCancel2"
    @closed="uploadClosed"
  >
    <div id="explorer">
      <div class="header">
        <div class="left">
          <el-button
            type="primary"
            icon="UploadFilled"
            @click="dialogVisible = true"
            >上传</el-button
          >

          <el-checkbox v-model="delstate" label="编辑" size="large" v-if="type=='radio'"/>

          <el-button
            v-if="type!='radio'||type=='radio'&&delstate"
            type="danger"
            icon="Delete"
            @click="delImg(checkedData, true)"
            >批量删除</el-button
          >
        </div>
        <div class="right">
          <el-input
            v-model="name"
            placeholder="请输入关键词"
            class="input-with-select"
            :clearable="true"
          >
            <template #prepend>
              <el-button icon="Search" />
            </template>
            <template #append>
              <el-select
                v-model="selectId"
                placeholder="Select"
                style="width: 128px"
                @change="selected"
                placement="bottom-end"
              >
                <el-option
                  v-for="(item, index) in selectData"
                  :key="index"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </template>
          </el-input>
        </div>
      </div>

      <el-scrollbar>
        <div class="body">
          <el-empty
            description="暂无图片,请上传图片"
            :image="require('@/assets/images/empty.png')"
            v-show="fileData.length == 0"
          />
          <div
            :class="
              'item' +
              (checkedData.find((item2) => item2.id == item.id)
                ? ' checked'
                : '')
            "
            v-for="(item, index) in fileData"
            :key="item.id"
          >
            <el-image :src="$dataConver.urlFilter(item.url)" fit="cover" />
            <p>{{ item.name }}</p>
            <span>{{ sizeFilter(item.size) }}</span>

            <div class="function">
              <el-icon @click="showImgViewer(index)"><ZoomIn /></el-icon>
              <el-icon @click="delImg(item.id)"><Delete /></el-icon>
            </div>
            <el-icon class="radio" @click="checkedToggle(item)"
              ><Select
            /></el-icon>
          </div>
        </div>
      </el-scrollbar>

      <el-image-viewer
        @close="closeImgViewer"
        :url-list="imageList"
        :initial-index="imageIndex"
        v-if="imageState"
        :hide-on-click-modal="true"
      />

      <el-pagination
        background
        layout="prev, pager, next"
        v-model:current-page="page"
        :total="fileSum"
        @current-change="pageChange"
      />

      <el-dialog
        v-model="dialogVisible"
        title="上传图片"
        :width="$store.state.screenWidth > 1200 ? '45%' : '98%'"
        align-center
        @close="uploadCancel"
      >
        <el-upload
          ref="upload"
          class="upload-demo"
          drag
          :action="action"
          multiple
          accept="image/*,video/*"
          v-model:file-list="fileList"
          :limit="20"
          :show-file-list="false"
          :on-change="handleChange"
          :auto-upload="false"
        >
          <el-icon class="el-icon--upload"><upload-filled /></el-icon>
          <div class="el-upload__text">在此扔下文件或 <em>点击上传</em></div>
          <template #tip>
            <div class="el-upload__tip">
              上传提示：小于1MB的jpg/jpeg/png/svg文件
            </div>
          </template>
        </el-upload>

        <div class="fileList">
          <div class="item" v-for="(item, index) in fileList" :key="item.uid">
            <span class="name">{{ item.name }}</span>
            <div class="progressBox">
              <span
                >{{ item.chunkSize ? sizeFilter(item.chunkSize) : 0 }}/{{
                  sizeFilter(item.size)
                }}</span
              >
              <el-progress
                :percentage="item.progress || 0"
                :show-text="false"
                color="#059669"
              />
            </div>
            <div class="state">
              <el-button
                v-if="!item.state"
                @click="delFile(index)"
                text
                bg
                icon="CircleClose"
              ></el-button>
              <span v-else-if="item.state == 1">进行中</span>
              <span v-else-if="item.state == 2">排队中</span>
              <span v-else-if="item.state == 3">已完成</span>
              <span v-else-if="item.state == 4" style="color: rgb(240, 85, 86)"
                >失败</span
              >
            </div>
          </div>
        </div>

        <template #footer>
          <span class="dialog-footer">
            <el-button @click="uploadCancel" v-if="false">取消</el-button>
            <el-button
              type="primary"
              @click="uploadConfirm"
              :disabled="uploadState"
              >上传</el-button
            >
          </span>
        </template>
      </el-dialog>
    </div>

    <template #footer v-if="type!='radio'">
      <span class="dialog-footer">
        <el-button @click="uploadCancel2">取消</el-button>
        <el-button type="primary" @click="uploadConfirm2">确定</el-button>
      </span>
    </template>
  </el-dialog>
</template>

<script>
import { reactive, toRefs, computed, getCurrentInstance, watch } from "vue";
import { ElMessage, ElMessageBox, genFileId } from "element-plus";
import { useStore } from "vuex";
import md5 from "js-md5";
export default {
  name: "photoInfo",
  props: {
    //选择图片弹窗显示状态
    visible: {
      type: Boolean,
      default: false,
    },
    //文件资源数据
    fileData: {
      type: Array,
      default: [],
    },
    //文件资源总数
    fileSum: {
      type: Number,
      default: 0,
    },
    //文件资源类型id
    select: {
      type: Number,
      default: 1,
    },
    //文件资源类型id
    type: {
      type: String,
      default: "radio",
    },
  },
  emits: ["query", "close", "confirm", "selected"],
  setup(props, { emit }) {
    let data = reactive({
      //图片资源类型
      selectData: [
        {
          label: "门店logo",
          value: 2,
        },
        {
          label: "门店图片",
          value: 201,
        }
      ],
      //文件筛选内容
      name: "",
      //文件资源类型id
      selectId: props.select,
      //文件列表
      fileList: [],
      //预览图片状态
      imageState: false,
      //预览图片下标
      imageIndex: 0,
      //上传弹窗状态
      dialogVisible: false,
      //文件上传对象
      upload: "",
      //文件上传地址
      action: "",
      //选中图片id
      checkedData: [],
      //当前分页
      page: 1,
      //上传弹窗状态
      dialogVisible2: props.visible,
      //vuex
      vuex: useStore(),
      //输入框节流阀状态
      // throttleState:true
      //上传分片大小
      chunkSize: 4 * 1024 * 1024,
      //上传分片禁用状态
      uploadState: false,
      //批量删除状态
      delstate:false
    });

    //监听设施下标变化
    watch(
      () => props.visible,
      (newValue, oldValue) => {
        data.dialogVisible2 = newValue;
      }
    );
    //监听下拉选项变化
    watch(
      () => props.select,
      (newValue, oldValue) => {
        data.selectId = newValue;
      }
    );
    watch(
      () => data.selectId,
      (newValue, oldValue) => {
        data.page = 1;
        emit("query", { page: data.page, select: newValue, name: data.name });
      }
    );
    //监听筛选内容变化
    watch(
      () => data.name,
      (newValue, oldValue) => {
        // if(data.throttleState){
        data.throttleState = false;
        data.page = 1;
        emit("query", {
          page: data.page,
          select: data.selectId,
          name: newValue,
        });
        // setTimeout(()=>{
        //   data.throttleState=true;
        // },100);
        // }
      }
    );

    watch(
      () => data.delstate,
      (newValue, oldValue) => {
        if(!newValue){
          data.checkedData=[];
        }
      }
    );

    //获取公共方法
    let { proxy } = getCurrentInstance();
    //预览图片列表
    const imageList = computed(() => {
      let arr = props.fileData.map((item) => {
        return data.vuex.state.ip + item.url;
      });
      return arr;
    });
    //关闭预览图片
    const closeImgViewer = () => {
      data.imageState = false;
    };
    //打开预览图片
    const showImgViewer = (index) => {
      data.imageState = true;
      data.imageIndex = index;
    };
    //删除图片资源
    const delImg = (id, all = false) => {
      if (all && data.checkedData.length == 0) {
        ElMessage({
          type: "warning",
          message: "请勾选图片!",
        });
        return false;
      }
      if (all) {
        id = id.map((item) => item.id).join(",");
      } else {
        id += "";
      }
      ElMessageBox.confirm(
        `此操作将永久删除${all ? "选中" : "该"}图片, 是否继续?`,
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }
      )
        .then(() => {
          proxy.$http
            .post("webapi/resource_mgr", {
              item: "del",
              id,
            })
            .then(({ data: res }) => {
              if (res.code == 0) {
                ElMessage({
                  type: "success",
                  message: "删除成功!",
                });
                data.page = 1;
                emit("query", { page: data.page, select: data.selectId });
              } else {
                ElMessage({
                  type: "error",
                  message: "删除失败!",
                });
              }
            })
            .catch((err) => {
              console.log("删除失败");
            });
        })
        .catch(() => {
          console.log("取消");
        });
    };
    //上传文件列表超出限制
    const handleExceed = (files) => {
      data.upload.clearFiles();
      const file = files[0];
      file.uid = genFileId();
      data.upload.handleStart(file);
    };
    //上传文件列表变化
    const handleChange = (uploadFile, uploadFiles) => {
      let ext = uploadFile.name.split(".").splice(-1)[0];
      let type = uploadFile.raw.type.split("/")[0];
      let size = uploadFile.raw.size;
      if (
        type == "image" &&
        ext != "svg" &&
        ext != "png" &&
        ext != "jpg" &&
        ext != "jpeg"
      ) {
        ElMessage({
          type: "warning",
          message: "文件类型不支持",
        });
        data.upload.handleRemove(uploadFile);
        return false;
      } else if (type == "image" && size > 1024 * 1024) {
        ElMessage({
          type: "warning",
          message: "图片大小最大不超过1MB",
        });
        data.upload.handleRemove(uploadFile);
        return false;
      }
      proxy.$http
        .get("webapi/resource_upload_ready", {
          params: {
            type,
            ext: "." + ext,
            size,
          },
        })
        .then(({ data: res }) => {
          if (res.code == 1039) {
            ElMessage({
              type: "warning",
              message: res.msg,
            });
            data.upload.handleRemove(uploadFile);
          }
        })
        .catch((err) => {
          console.log("图片上传地址请求失败");
        });
    };
    //分片上传请求
    let uploadurlGet = (uploadFile, index) => {
      return new Promise((reslove, reject) => {
        proxy.$http
          .get("webapi/resource_upload_ready", {
            params: {
              type: uploadFile.raw.type.split("/")[0],
              ext: "." + uploadFile.name.split(".").splice(-1)[0],
              size: uploadFile.raw.size,
            },
          })
          .then(({ data: res }) => {
            data.action = res.data.upload_url;
            reslove(true);
          })
          .catch((err) => {
            data.fileList[index].state = 4;
            data.fileList[index].progress = 0;
            data.fileList[index].chunkSize = 0;
            reject(false);
          });
      });
    };
    //上传文件确认
    let uploadConfirm = () => {
      if (data.fileList.length == 0) {
        ElMessage({
          type: "warning",
          message: "请先上传文件!",
        });
        return false;
      }

      (async () => {
        data.uploadState = true;
        data.fileList.forEach((item) => {
          item.state = 2;
        });
        for (let x = 0; x < data.fileList.length; x++) {
          let result = await uploadurlGet(data.fileList[x], x);
          if (!result) {
            continue;
          }
          await chunk(data.fileList[x], x);
        }
        data.uploadState = false;
        data.dialogVisible = false;
        data.upload.clearFiles();
        data.page = 1;
        emit("query", { page: data.page, select: data.selectId });
      })();
    };
    let chunk = (file, index) => {
      return new Promise(async (reslove, reject) => {
        let start = 0;
        let ok = 0;
        while (start < file.size) {
          let blob = null;
          if (start + data.chunkSize > file.size) {
            ok = 1;
            blob = file.raw.slice(start, file.size);
          } else {
            blob = file.raw.slice(start, start + data.chunkSize);
          }
          start += data.chunkSize;
          let formData = new FormData();
          formData.append("upfile", blob, file.name);
          formData.append("hash", md5(file.name + "_" + file.size));
          formData.append("name", file.name);
          formData.append("fileSize", file.size);
          formData.append("ok", ok);
          formData.append("action", "upload");
          await proxy.$http
            .post(data.action, formData)
            .then(({ data: res }) => {
              data.fileList[index].state = 1;
              data.fileList[index].progress = (start / file.size) * 100;
              data.fileList[index].chunkSize = start;
              if (ok == 1 && res.code == 0) {
                data.fileList[index].state = 3;
                data.fileList[index].progress = 100;
                data.fileList[index].chunkSize = file.size;
                fileAdd(res.data, file.raw.type.split("/")[0]);
              }
            })
            .catch((err) => {
              reject("图片上传失败");
            });
        }
        reslove(1);
      });
    };
    //上传文件取消/关闭
    let uploadCancel = () => {
      data.dialogVisible = false;
      data.uploadState = false;
      data.upload.clearFiles();
    };
    //图片添加
    let fileAdd = (obj, type) => {
      proxy.$http
        .post("webapi/resource_mgr", {
          item: "add",
          type,
          hash: obj.hash,
          name: obj.name,
          pid: data.selectId,
        })
        .then(({ data: res }) => {
          if (res.code == 0) {
            ElMessage({
              type: "success",
              message: obj.name + "文件上传成功!",
            });
          } else {
            ElMessage({
              type: "error",
              message: "上传文件失败!",
            });
          }
        })
        .catch((err) => {
          console.log("图片添加失败");
        });
    };
    //文件大小过滤
    let sizeFilter = (size) => {
      if (size > 1024 && size < 1024 * 1024) {
        return parseFloat((size / 1024).toFixed(2)) + "KB";
      } else if (size > 1024 * 1024 && size < 1024 * 1024 * 1024) {
        return parseFloat((size / (1024 * 1024)).toFixed(2)) + "MB";
      } else if (size > 1024 * 1024 && size < 1024 * 1024 * 1024) {
        return parseFloat((size / (1024 * 1024 * 1024)).toFixed(2)) + "G";
      } else {
        return parseFloat(size.toFixed(2)) + "B";
      }
    };
    //当前分页变动
    let pageChange = (e) => {
      data.page = e;
      // emit("query", { page: data.page });
      emit("query", { page: data.page, select: data.selectId, name: data.name });
    };
    //选择图片取消/关闭
    let uploadCancel2 = () => {
      emit("close");
    };
    //图片资源弹窗关闭回调
    let uploadClosed = () => {
      data.page = 1;
      data.checkedData = [];
    };
    //选择图片确认
    let uploadConfirm2 = () => {
      if (data.checkedData) {
        if(props.type=="radio"){
          emit("confirm", data.checkedData[0]);
        }else{
          emit("confirm", data.checkedData);
        }
      } else {
        ElMessage({
          type: "warning",
          message: "请选择图片!",
        });
      }
    };
    //选择图片分类
    let selected = (val) => {
      emit("selected", val);
    };
    //删除文件列表文件
    let delFile = (index) => {
      data.fileList.splice(index, 1);
    };
    //文件切换状态
    let checkedToggle = (obj) => {
      if (props.type == "radio") {
        if(data.delstate){
          let index = data.checkedData.findIndex((item) => item.id == obj.id);
          if (index == -1) {
            data.checkedData.push(obj);
          } else {
            data.checkedData.splice(index, 1);
          }
        }else{
          data.checkedData[0]=obj;
          emit("confirm", data.checkedData[0]);
        }
      } else if (props.type == "checked") {
        let index = data.checkedData.findIndex((item) => item.id == obj.id);
        if (index == -1) {
          data.checkedData.push(obj);
        } else {
          data.checkedData.splice(index, 1);
        }
      }
    };

    return {
      ...toRefs(data),
      imageList,
      closeImgViewer,
      showImgViewer,
      delImg,
      handleExceed,
      handleChange,
      uploadConfirm,
      uploadConfirm2,
      uploadCancel,
      uploadCancel2,
      fileAdd,
      sizeFilter,
      pageChange,
      selected,
      uploadClosed,
      delFile,
      checkedToggle,
    };
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/css/moduleChild/explorer.scss";
</style>